<template>
  <div v-loading="loading" class="registerContent">
    <el-form ref="form" :model="form" label-width="253px">
      <el-form-item label="开启身份认证：">
        <el-radio-group v-model="form.isAuth" @change="isAuthChange">
          <el-radio :label="1">是</el-radio>
          <el-radio :label="0">否</el-radio>
        </el-radio-group>
      </el-form-item>
      <div class="authContent" :class="form.isAuth == 0 ? '' : ''">
        <el-form-item label="认证方式选择：">
          <el-radio-group v-model="form.authType" :disabled="form.isAuth == 0 ? true : false">
            <el-radio :label="1">实名认证</el-radio>
            <el-radio :label="2" disabled>医生认证</el-radio>
            <el-radio :label="3" disabled>实名+医生认证</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="必须身份认证通过访问小程序：">
          <el-radio-group
            v-model="form.mustAuthToMini"
            :disabled="form.isAuth == 0 ? true : false"
            @change="mustAuthToMiniChange"
          >
            <el-radio :label="1">是</el-radio>
            <el-radio :label="0">否</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="允许跳过身份认证：">
          <el-radio-group v-model="form.allowSkipAuth" :disabled="form.isAuth == 0 ? true : false">
            <el-radio
              :label="1"
              :disabled="!(Number(form.isAuth) === 1 && Number(form.mustAuthToMini) === 0)"
            >
              是
            </el-radio>
            <el-radio :label="0">否</el-radio>
          </el-radio-group>
        </el-form-item>
      </div>
      <el-form-item label="允许邀约医生库外的联系人：">
        <el-radio-group v-model="form.allowInviteWithout" @change="canInviceOutDoor">
          <el-radio :label="1">是</el-radio>
          <el-radio :label="0">否</el-radio>
        </el-radio-group>
      </el-form-item>
      <div class="allowInviteWithout" :class="form.allowInviteWithout == 0 ? '' : ''">
        <el-form-item label="是否允许待验证医生访问内容：">
          <el-radio-group
            v-model="form.waitForVerificationCanVisit"
            :disabled="form.allowInviteWithout == 0 ? true : false"
          >
            <el-radio :label="1">是</el-radio>
            <el-radio :label="0">否</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="是否允许待验证医生参加会议：">
          <el-radio-group
            v-model="form.waitForVerificationCanMeeting"
            :disabled="form.allowInviteWithout == 0 ? true : false"
          >
            <el-radio :label="1">是</el-radio>
            <el-radio :label="0">否</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="待验证医生是否作为参会考核人：">
          <el-radio-group
            v-model="form.waitForVerificationAuditorOrNot"
            :disabled="form.allowInviteWithout == 0 ? true : false"
          >
            <el-radio :label="1">是</el-radio>
            <el-radio :label="0">否</el-radio>
          </el-radio-group>
        </el-form-item>
      </div>
      <el-form-item label="二维码类型：">
        <el-radio-group v-model="form.erweimaType">
          <el-radio :label="1">公众号二维码</el-radio>
          <el-radio :label="0">小程序码</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="授权书是否可置于注册页内：">
        <el-radio-group v-model="form.authorizationInRegister">
          <el-radio :label="1">是</el-radio>
          <el-radio :label="0">否</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="领域标签是否可跳过：">
        <el-radio-group v-model="form.fieldTagIsSkip">
          <el-radio :label="1">是</el-radio>
          <el-radio :label="0">否</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="可选领域标签上限：">
        <CountNumberInput
          :can-max-num="2"
          @emitInput="maxTagInput"
          :props-value="form.maxTagNumber"
        />
      </el-form-item>
    </el-form>
    <button class="saveButton" @click="onSubmit">保存</button>
    <DialogComp title2="是否保存" :dialog-visible="dialogVisible" @dialogEmit="saveWrite" />
  </div>
</template>
<script>
import CountNumberInput from '@/components/countNumberInput';
import DialogComp from '@/components/orange-dialog';
export default {
  name: 'RegisterAuth',
  components: {
    CountNumberInput,
    DialogComp,
  },
  data() {
    return {
      loading: false,
      form: {
        isAuth: 1 /* 开启身份认证： */,
        authType: 1 /* 认证方式选择： */,
        mustAuthToMini: 1 /* 必须身份认证通过访问小程序： */,
        allowSkipAuth: 0 /* 允许跳过身份认证： */,
        allowInviteWithout: 1 /* 允许邀约医生库外的联系人： */,
        waitForVerificationCanVisit: 0 /* 是否允许待验证医生访问内容： */,
        waitForVerificationCanMeeting: 0 /* 是否允许待验证医生参加会议： */,
        waitForVerificationAuditorOrNot: 0 /* 待验证医生是否作为参会考核人： */,
        erweimaType: 1 /* 二维码类型： */,
        authorizationInRegister: 1 /* 授权书是否可置于注册页内：*/,
        fieldTagIsSkip: 0 /* 领域标签是否可跳过： */,
        maxTagNumber: 2 /* 可选领域标签上限： */,
      },
      configType: 80, // 配置类型
      id: undefined, // 企业配置ID
      dialogVisible: false, // 保存弹窗
    };
  },
  mounted() {
    this.init();
  },
  methods: {
    // 获取注册认证设置
    async init() {
      this.loading = true;
      const res = await this.$requestData('/api/companyConfig/manager/query', {});
      if (res.data?.code === 0) {
        const data = res.data.data?.filter((_) => _.configType === 80);
        if (data[0]) {
          this.id = data[0].id;
          const configText = JSON.parse(data[0]?.configText);
          console.log(configText);
          if (configText) {
            this.$nextTick(() => {
              this.form = Object.assign(
                {},
                {
                  isAuth: configText.isAuth,
                  authType: configText.authType,
                  mustAuthToMini: configText.mustAuthToMini,
                  allowSkipAuth: configText.allowSkipAuth,
                  allowInviteWithout: configText.allowInviteWithout,
                  erweimaType: configText.erweimaType,
                  authorizationInRegister: configText.authorizationInRegister,
                  fieldTagIsSkip: configText.fieldTagIsSkip,
                  maxTagNumber: configText.maxTagNumber,
                  waitForVerificationCanVisit: configText.waitForVerificationCanVisit,
                  waitForVerificationCanMeeting: configText.waitForVerificationCanMeeting,
                  waitForVerificationAuditorOrNot: configText.waitForVerificationAuditorOrNot,
                },
              );
            });
          }
        }
      }
      this.loading = false;
    },
    /* 可选领域标签上限: 文本输入框上传值 */
    maxTagInput(value) {
      this.form.maxTagNumber = value;
    },
    /* 必须身份认证通过访问小程序改变 */
    mustAuthToMiniChange(value) {
      if (value === 1) {
        this.$set(this.form, 'allowSkipAuth', 0);
      }
    },
    /* 是否开启身份认证 */
    isAuthChange(val) {
      if (val === 0) {
        this.$set(this.form, 'authType', null);
        this.$set(this.form, 'mustAuthToMini', null);
        this.$set(this.form, 'allowSkipAuth', null);
      } else {
        this.$set(this.form, 'authType', 1);
        this.$set(this.form, 'mustAuthToMini', 1);
        this.$set(this.form, 'allowSkipAuth', 0);
      }
    },
    /* 是否允许邀请外部联系人 */
    canInviceOutDoor(val) {
      // console.log(this.form)
      if (val === 0) {
        this.$set(this.form, 'waitForVerificationCanVisit', null);
        this.$set(this.form, 'waitForVerificationCanMeeting', null);
        this.$set(this.form, 'waitForVerificationAuditorOrNot', null);
      } else {
        this.$set(this.form, 'waitForVerificationCanVisit', 0);
        this.$set(this.form, 'waitForVerificationCanMeeting', 0);
        this.$set(this.form, 'waitForVerificationAuditorOrNot', 0);
      }
    },
    // 提交数据
    async saveForm() {
      this.loading = true;

      const res = await this.$requestData('/api/companyConfig/manager/saveCompanyConfig', {
        requests: [
          {
            configText: JSON.stringify({ ...this.form }),
            configType: this.configType,
            id: this.id,
          },
        ],
      });

      if (res.data?.code === 0) {
        this.$message.success('保存成功');
      }
      this.loading = false;
    },

    // 保存按钮
    async onSubmit() {
      this.dialogVisible = true;
    },

    // 提示框
    saveWrite(confirm) {
      if (!confirm) {
        this.dialogVisible = false;
        return;
      }

      this.saveForm();
      this.dialogVisible = false;
    },
  },
};
</script>
<style lang="scss" scoped>
@import './index.scss';
</style>
